// extracted by mini-css-extract-plugin
export default {"container":"Root_container__WSw5B","btn":"Root_btn__vUx8S","card":"Root_card__e1hNE","loading":"Root_loading__ekkK3","spin":"Root_spin__HY5Oh"};